import { PopoverContentProps, PopoverProps } from "@radix-ui/react-popover";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { FC } from "react";
import { DayPickerProps, SelectSingleEventHandler } from "react-day-picker";

import { Button } from "@/components/ui/button";
import { ButtonProps } from "@/components/ui/button/types";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/lib/utils";

type Props = {
  align?: PopoverContentProps["align"];
  open: PopoverProps["open"];
  className?: string;
  selected?: Date | undefined;
  onSelect?: SelectSingleEventHandler;
  onDismiss: PopoverProps["onOpenChange"];
  fromDate?: DayPickerProps["fromDate"];
  toDate?: DayPickerProps["toDate"];
  disabled: ButtonProps["disabled"];
};

const DATE_FORMAT = "LLL dd, y";

export const DatePicker: FC<Props> = ({
  align,
  open,
  className,
  selected,
  onSelect,
  onDismiss,
  fromDate,
  toDate,
  disabled,
}) => {
  const formatted = selected
    ? format(selected, DATE_FORMAT)
    : "Select a date range";

  return (
    <div className={cn("grid gap-2", className)}>
      <Popover open={open} onOpenChange={onDismiss}>
        <PopoverTrigger asChild>
          <Button
            id="date"
            variant="outline"
            disabled={disabled}
            className={cn(
              "justify-date?.from text-left font-normal",
              !selected && "text-muted-foreground",
            )}
          >
            <CalendarIcon />
            {formatted}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align={align}>
          <Calendar
            initialFocus
            mode="single"
            defaultMonth={selected}
            selected={selected}
            onSelect={onSelect}
            fromDate={fromDate}
            toDate={toDate}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};
